import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Header from './Header';
import classnames from 'classnames';
import ChildAside from './ChildAside';

import './Layout.scss';

const Layout = (props) => {
  //  Show footer after first render
  useEffect(() => {
    document.getElementById('footer').style.display = 'block';
  }, []);

  return (
    <div className={classnames('layout', { child: props.isChild })}>
      <div className="main-container">
        <Header onBack={props.onBack} />
        <main className="main">{props.children}</main>
        <ChildAside isChild={props.isChild} />
      </div>
    </div>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
  onBack: PropTypes.func,
  isChild: PropTypes.bool,
};

export default Layout;
